import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { resolveElements } from '../render/dom/utils/resolve-element.mjs';
import { visualElementStore } from '../render/store.mjs';
import { invariant } from '../utils/errors.mjs';
import { GroupPlaybackControls } from './GroupPlaybackControls.mjs';
import { isDOMKeyframes } from './utils/is-dom-keyframes.mjs';
import { animateTarget } from './interfaces/visual-element-target.mjs';
import { createVisualElement } from './utils/create-visual-element.mjs';
import { animateSingleValue } from './interfaces/single-value.mjs';
import { createAnimationsFromSequence } from './sequence/create.mjs';
import { isMotionValue } from '../value/utils/is-motion-value.mjs';
function animateElements(elementOrSelector, keyframes, options, scope) {
  var elements = resolveElements(elementOrSelector, scope);
  var numElements = elements.length;
  invariant(Boolean(numElements), "No valid element provided.");
  var animations = [];
  for (var i = 0; i < numElements; i++) {
    var element = elements[i];
    /**
     * Check each element for an associated VisualElement. If none exists,
     * we need to create one.
     */
    if (!visualElementStore.has(element)) {
      /**
       * TODO: We only need render-specific parts of the VisualElement.
       * With some additional work the size of the animate() function
       * could be reduced significantly.
       */
      createVisualElement(element);
    }
    var visualElement = visualElementStore.get(element);
    var transition = _objectSpread({}, options);
    /**
     * Resolve stagger function if provided.
     */
    if (typeof transition.delay === "function") {
      transition.delay = transition.delay(i, numElements);
    }
    animations.push.apply(animations, _toConsumableArray(animateTarget(visualElement, _objectSpread(_objectSpread({}, keyframes), {}, {
      transition: transition
    }), {})));
  }
  return new GroupPlaybackControls(animations);
}
var isSequence = function isSequence(value) {
  return Array.isArray(value) && Array.isArray(value[0]);
};
function animateSequence(sequence, options, scope) {
  var animations = [];
  var animationDefinitions = createAnimationsFromSequence(sequence, options, scope);
  animationDefinitions.forEach(function (_ref, subject) {
    var keyframes = _ref.keyframes,
      transition = _ref.transition;
    var animation;
    if (isMotionValue(subject)) {
      animation = animateSingleValue(subject, keyframes.default, transition.default);
    } else {
      animation = animateElements(subject, keyframes, transition);
    }
    animations.push(animation);
  });
  return new GroupPlaybackControls(animations);
}
var createScopedAnimate = function createScopedAnimate(scope) {
  /**
   * Implementation
   */
  function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
    var animation;
    if (isSequence(valueOrElementOrSequence)) {
      animation = animateSequence(valueOrElementOrSequence, keyframes, scope);
    } else if (isDOMKeyframes(keyframes)) {
      animation = animateElements(valueOrElementOrSequence, keyframes, options, scope);
    } else {
      animation = animateSingleValue(valueOrElementOrSequence, keyframes, options);
    }
    if (scope) {
      scope.animations.push(animation);
    }
    return animation;
  }
  return scopedAnimate;
};
var animate = createScopedAnimate();
export { animate, createScopedAnimate };